module.exports = __webpack_public_path__ + "img/spoon.89bda7da.svg";